import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  OauthAEMConfig,
  SubmitEmailResponse,
  SubmitSmsNumber
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class ResendOtpService {
  resendOTPHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.resendOtp+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  resendOTP = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<SubmitSmsNumber | SubmitEmailResponse> => {
    const removeMFAMethod = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const removeMFAMethodUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: removeMFAMethod
      }
    ];

    return new ApiBuilder<undefined, SubmitSmsNumber | SubmitEmailResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(removeMFAMethodUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.resendOTPHeader)
      .errorHandler(this._errorHandler)
      .library('RESEND_OTP_METHOD_SERVICE')
      .withCredentials(true)
      .create();
  };
}
